const schema = {
    event: "string",
    event_type: "string",
    ecommerce: {
        value: "number",
        currency: "string",
        items: [
            {
                item_id: "string",
                item_name: "string",
                item_brand: "string",
                item_category: "string",
                item_category2: "string",
                origin: "string",
                price: "number",
                quantity: "number",
            }
        ]
    }
}

export default function addKeysToSchema(itemKeys = {}, ecommerceKeys = {}) {
    return {
        ...schema,
        ecommerce: {
            ...schema.ecommerce,
            ...ecommerceKeys,
            items: schema.ecommerce.items.map(item => ({...item, ...itemKeys}))
        }
    };
}